import { useEffect, useState } from "react";
import { FaInstagram, FaUserTie } from "react-icons/fa";
import { MdSupportAgent } from "react-icons/md";
import { FaUser, FaLock } from "react-icons/fa";
import { ImSearch } from "react-icons/im";
import { TiHeartOutline, TiShoppingCart } from "react-icons/ti";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_card_products,
  get_wishlist_products,
} from "../store/reducers/cardReducer";
import logo from "../assets/apna-plaza-logo-dark.png";

const Headers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categorys } = useSelector((state) => state.home);
  const { userInfo } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card,
  );

  const { pathname } = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const [category, setCategory] = useState("");

  const search = () => {
    navigate(`/products/search?category=${category}&&value=${searchValue}`);
  };
  const redirect_card_page = () => {
    if (userInfo) {
      navigate(`/card`);
    } else {
      navigate(`/login`);
    }
  };

  useEffect(() => {
    if (userInfo) {
      dispatch(get_card_products(userInfo.id));
      dispatch(get_wishlist_products(userInfo.id));
    }
  }, [dispatch, userInfo]);
  return (
    <div className="w-full bg-primaryBackground backdrop-blur-md shadow-secondary !shadow-lg drop-shadow ">
      <div className="header-top bg-primary md-lg:hidden">
        <div className="container mx-auto">
          <div className="flex w-full justify-between items-center h-[50px] text-slate-300">
            <ul className="flex justify-start items-center gap-8">
              <li className="flex relative text-sm justify-center items-center gap-2 after:absolute after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]">
                <span>
                  <MdSupportAgent />
                </span>
                <Link to={"/contact"}>Contact Us</Link>
              </li>
              <li className="flex relative text-sm justify-center items-center gap-2">
                <span>
                  <FaUserTie />
                </span>
                <Link to={"https://apnaplaza.vercel.app/seller/register"}>
                  Become a Seller
                </Link>
              </li>
            </ul>
            <div>
              <div className="flex justify-center items-center gap-10">
                <div className="flex justify-center items-center gap-4">
                  {/* <a className='text-slate-300 hover:text-secondary' href="#"><FaFacebookF /></a>
                                    <a className='text-slate-300 hover:text-secondary' href="#"><AiOutlineTwitter /></a> */}
                  <a
                    className="text-slate-300 hover:text-secondary"
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.instagram.com/tweaksandtucks?utm_source=qr&igsh=NTc4MTIwNjQ2YQ== "
                  >
                    <FaInstagram />
                  </a>
                </div>

                {userInfo ? (
                  <Link
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm"
                    to="/dashboard/my-wishlist"
                  >
                    <span>
                      <FaUser />
                    </span>
                    <span>{userInfo.name}</span>
                  </Link>
                ) : (
                  <Link
                    to="/login"
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm"
                  >
                    <span>
                      <FaLock />
                    </span>
                    <span>Login</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="container mx-auto">
          <div className="h-[80px] flex justify-between items-center flex-wrap">
            <div className="md-lg:w-full max-w-[300px] sm:max-w-fit">
              <Link to="/">
                <img height="auto" className="w-[230px] sm:w-[170px]" src={logo} alt="Logo" />
              </Link>
            </div>
            <div className="md-lg:w-full md:w-fit w-[70%]">
              <div className="flex justify-between header-nav xl:justify-evenly items-center flex-wrap sm:pl-0 pl-8">
                <ul className="flex justify-center  items-center gap-3 text-base xl:text-sm font-semibold capitalize md:hidden">
                  <li
                    className={`p-2 block ${pathname === "/" ? "text-secondary" : "text-primary"}`}
                  >
                    <Link
                      to="/"
                      className={`p-2 block ${pathname === "/" ? "text-secondary" : "text-primary"}`}
                    >
                      Home
                    </Link>
                  </li>
                  <li
                    className={`p-2 block ${pathname === "/products" ? "text-secondary" : "text-primary"}`}
                  >
                    <Link
                      to="/products"
                      className={`p-2 block ${pathname === "/products" ? "text-secondary" : "text-primary"}`}
                    >
                      Products
                    </Link>
                  </li>
                  <li
                    className={`p-2 block ${pathname === "/sellers" ? "text-secondary" : "text-primary"}`}
                  >
                    <Link
                      to="/sellers"
                      className={`p-2 block ${pathname === "/sellers" || pathname === "/sellers/" ? "text-secondary" : "text-primary"}`}
                    >
                      Sellers
                    </Link>
                  </li>
                  {/* <li className={`p-2 block ${pathname === '/about' ? 'text-secondary' : 'text-primary'}`}>
                                        <Link to='/about' className={`p-2 block ${pathname === '/about' ? 'text-secondary' : 'text-primary'}`}>
                                            About
                                        </Link>
                                    </li> */}
                  <li className="xl:hidden">
                    <div className=" md-lg:w-full">
                      <div className="flex border-2 h-[50px] items-center inputContainer relative gap-5">
                        <div className="relative  after:absolute after:h-[25px] after:w-[1px] after:bg-secondary/40 after:-right-[15px] md:hidden">
                          <select
                            onChange={(e) => setCategory(e.target.value)}
                            className=" text-primary font-semibold bg-transparent px-2 h-full outline-0 border-none"
                            name=""
                            id=""
                          >
                            <option value="">Select category</option>
                            {categorys.map((c, i) => (
                              <option key={i} value={c.name}>
                                {c.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <input
                          className="w-full relative drop-shadow-lg bg-transparent font-normal text-slate-500 outline-0 px-3 h-full"
                          onChange={(e) => setSearchValue(e.target.value)}
                          type="text"
                          name=""
                          id=""
                          placeholder="What do you need?"
                        />
                        <button
                          onClick={search}
                          className="bg-primary rounded-[10px] right-0 absolute px-3 h-9 mr-1 font-semibold uppercase text-card"
                        >
                          <ImSearch />
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="flex justify-center xl:justify-end items-center gap-4">
                  <div className="flex justify-center gap-x-6 sm:gap-x-3">
                    <button
                      onClick={() =>
                        navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
                      }
                      className="relative flex justify-center items-center cursor-pointer"
                    >
                      <span className="text-3xl text-primary sm:text-[26px]">
                        <TiHeartOutline />
                      </span>
                      {wishlist_count !== 0 && (
                        <div className="w-[18px] h-[18px] absolute text-xs bg-secondary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                          {wishlist_count}
                        </div>
                      )}
                    </button>
                    <button
                      onClick={redirect_card_page}
                      className="relative flex justify-center items-center cursor-pointer"
                    >
                      <span className="text-3xl text-primary sm:text-[26px]">
                        <TiShoppingCart />
                      </span>
                      {card_product_count !== 0 && (
                        <div className="w-[18px] h-[18px] absolute bg-secondary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                          {card_product_count}
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='hidden md-lg:block'>
                <div className='w-[85%] mx-auto my-0'>
                    <div className='flex border rounded-[10px] drop-shadow-lg h-[50px] items-center relative gap-5'>

                        <input className='w-full relative  bg-transparent text-slate-500 outline-0 px-3 h-full' onChange={(e) => setSearchValue(e.target.value)} type="text" name="" id="" placeholder='what do you need' />
                        <button onClick={search} className='bg-secondary rounded-[10px] right-0 absolute px-4 h-full font-semibold uppercase text-white'><ImSearch /></button>
                    </div>
                </div>
            </div> */}
    </div>
  );
};

export default Headers;
